const getTeamCodeByHost = () => {
  switch (document.location.hostname) {
    case "localhost":
      return "EA9999";
    case "rider.easyride.tw":
      return "EA9999";
    case "gotoairport.tw":
    case "www.gotoairport.tw":
    case "rider.gotoairport.tw":
      return "EA9997"
    default:
      return "";
  }
}

export default getTeamCodeByHost;
